import { useFormContext, useFormState, useWatch } from 'react-hook-form';
import useEventCallback from '@mui/utils/useEventCallback';
import { looseValueEqual } from '@cbridge-utils/shared-helpers';

export const useHasChanges = () => {
  const { isDirty, defaultValues, isSubmitSuccessful } = useFormState();
  const values = useWatch();

  return isDirty && !isSubmitSuccessful && !looseValueEqual(defaultValues, values);
};

/**
 * Same condition as `useHasChanges`, but read from the live form state on call:
 * the render-based value is stale until React re-renders, which can happen
 * after a navigation attempt (e.g. redirect right after a successful submit).
 */
export const useHasChangesNow = () => {
  const { formState, getValues } = useFormContext();

  return useEventCallback(
    () => formState.isDirty && !formState.isSubmitSuccessful && !looseValueEqual(formState.defaultValues, getValues()),
  );
};
